import React, {useState} from 'react';
import classes from './MemberAccount.css';
import PersonalInfo from './PersonalInfo/PersonalInfo';
import AccountStatus from './AccountStatus/AccountStatus';
import HealthSafeIdData from './HealthSafeIdData/HealthSafeIdData';
import ResetAccount from './ResetAccount/ResetAccount';
import Message from '../../../components/Message/Message';
import OtpVerification from './OtpVerification/OtpVerification';
import { SESSION_READONLYUSER, SESSION_SUPERUSER, SESSION_BASELINEAGENT, HSID_BASE, SESSION_SUPERVISORUSER } from '../../../shared/Constants';
import { isPartialRegistration } from '../../../shared/utility';
import Button from '../../../UI/Button/Button';


const memberAccount = (props) => {

    let expandCollapeLabel = 'Expand';
    let buttonClass = [classes.collapsible];
    let contentClass = [classes.Content];

    const [phoneUpdated, setPhoneUpdate] = useState(false);

    const isPhoneUpdated = (updatedValue) => {
        setPhoneUpdate(updatedValue);
    }
        
    if (props.expanded) {
        contentClass = [classes.Content, classes.ContentExpand];
        expandCollapeLabel = 'Collapse';

        buttonClass = [classes.collapsible, classes.active];
    }
    const otpVerificaitonNotifier = props.isOTPVerified ? null : <div className={classes.OTPMessageDiv}><Message msgType="Error" info={{ message: "Please verify Identity to edit." }} /></div>;

    let nonSuperUserDisplay = props.isHSID
        ?
        // HSID idType display
        <div className={contentClass.join(' ')} style={{ flexFlow: "column" }}>
            <div className={classes.MemberAccountFlexDiv}>
                <div className={classes.MemberAccountFlexOne}>
                    <PersonalInfo isPhoneUpdated={isPhoneUpdated} isOTPVerified={props.isOTPVerified} 
                    disableTab={props.idType===HSID_BASE ? "0" : (props.userType!==SESSION_BASELINEAGENT) && (props.isOTPVerified ? "0" : "-1")} idType={props.idType}/>
                </div>
                <div style={{ border: "0.5px solid lightgrey", background: "lightgrey" }}></div>
                <div className={classes.MemberAccountFlexOne}>
                    <HealthSafeIdData isOTPVerified={props.isOTPVerified}
                    disableTab={props.idType===HSID_BASE ? "0" : (props.userType!==SESSION_BASELINEAGENT) && (props.isOTPVerified ? "-1" : "-1")} idType={props.idType}/>
                </div>
            </div>
            <div className={classes.MemberAccountFlexDiv}>
                <div className={classes.PersonalInfo}>
                    <div style={{ width: "200%", height: "1px", background: "lightgrey", marginTop: "30px" }}></div>
                    <div style={{ height: "20px", width: "100%", margin: "10px", }}></div>
                    <AccountStatus isHeadlessUser={props.isHeadlessUser} userType={props.userType} isHSID={props.isHSID} idType={props.idType}/>
                    {!isPartialRegistration(props.idType) && props.idType!==HSID_BASE && <ResetAccount isHeadlessUser={props.isHeadlessUser} phoneUpdated={phoneUpdated} />}
                </div>
                {(props.userType!==SESSION_BASELINEAGENT && props.idType!==HSID_BASE) && <div className={classes.AccountStatus}>
                    <div style={{ height: "21px", width: "100%" }}></div>
                </div>}
            </div>
            { props.idType===HSID_BASE ? null : (props.userType!==SESSION_BASELINEAGENT) && (props.isOTPVerified ? null : <div className={classes.DisableLayer}></div>)}
        </div>
        :
        // NonMember idType display                                                 // redendant code
        <div className={contentClass.join(' ')}>
            <div className={classes.PersonalInfo}>
                <PersonalInfo isPhoneUpdated={isPhoneUpdated} idType={props.idType}/>
                <div style={{ height: "20px", width: "100%", margin: "10px", }}></div>
                <ResetAccount isHeadlessUser={props.isHeadlessUser} phoneUpdated={phoneUpdated}/>
            </div>
            <div style={{ border: "0.5px solid lightgrey", background: "lightgrey" }}></div>
            {props.userType!==SESSION_BASELINEAGENT &&<div className={classes.AccountStatus}>
                <AccountStatus isHeadlessUser={props.isHeadlessUser} userType={props.userType} isHSID={props.isHSID} idType={props.idType}/>
                <div style={{ height: "20px", width: "100%", margin: "10px" }}></div>
            </div>}
            {props.userType!==SESSION_BASELINEAGENT && (props.isOTPVerified ? null : <div className={classes.DisableLayer}></div>)}
        </div>

// readonly User display
    let readonlyUserDisplay = 
        <div className={contentClass.join(' ')} style={{ flexFlow: "column" }}>
            <div className={classes.MemberAccountFlexDiv}>
                <div className={classes.PersonalInfo}>
                    <AccountStatus isHeadlessUser={props.isHeadlessUser} userType={props.userType} isHSID={props.isHSID} idType={props.idType}/>
                </div>
            </div>
        </div>;


    let displayUser = ((props.userType===SESSION_SUPERUSER || props.userType===SESSION_SUPERVISORUSER) && props.isHSID)
        ?
        // Super User display
        <div className={contentClass.join(' ')} style={{ flexFlow: "column" }}>
            <div className={classes.MemberAccountFlexDiv}>
                <div className={classes.MemberAccountFlexOne}>
                    <PersonalInfo isPhoneUpdated={isPhoneUpdated} idType={props.idType}/>
                </div>
                <div style={{ border: "0.5px solid lightgrey", background: "lightgrey" }}></div>
                <div className={classes.MemberAccountFlexOne}>
                    <HealthSafeIdData isOTPVerified={props.userType===SESSION_SUPERVISORUSER && !props.isOTPVerified} idType={props.idType}/>
                </div>
            </div>
            <div className={classes.MemberAccountFlexDiv}>
                <div className={classes.PersonalInfo}>
                    <div style={{ width: "200%", height: "1px", background: "lightgrey", marginTop: "30px" }}></div>
                    <div style={{ height: "20px", width: "100%", margin: "10px", }}></div>
                    <AccountStatus isHeadlessUser={props.isHeadlessUser} userType={props.userType} isHSID={props.isHSID} idType={props.idType}/>
                    {!isPartialRegistration(props.idType) && props.idType!==HSID_BASE && <ResetAccount isHeadlessUser={props.isHeadlessUser} phoneUpdated={phoneUpdated} />}
                </div>
            </div>
        </div>
        :
        // Non Super User display
        <>
            {props.userType===SESSION_READONLYUSER ? readonlyUserDisplay : nonSuperUserDisplay  }
        </>

    return (
        <div className={classes.MemberAccount}>
            <div className={classes.MemberAccountHeader}>
            <div className={classes.MemberAccountHeaderLeftEndDiv}>
                {props.userType==SESSION_SUPERUSER &&  
                <Button className={classes.createIncident} id="createIncident" btnType="Search" clicked={props.createIncidentHandler}>Create Incident</Button>}
            </div>
                <h2 className={classes.MemberAccountTitle}>Member Account</h2>
                {(props.userType!==SESSION_BASELINEAGENT && props.idType!==HSID_BASE) && otpVerificaitonNotifier}
                <div className={classes.MemberAccountHeaderRightEndDiv}>
                <button className={buttonClass.join(' ')} onClick={props.expandHandler}>{expandCollapeLabel}</button>
                </div>
            </div>
            {displayUser}
        </div>
    );
}

export default memberAccount;